import { useEffect, useState } from "react";
import { Copy, Lock, Link2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, publicUrl } from "../../lib/api";
import { ESTADOS_UAF, fmtFecha } from "../../lib/format";
import { useAuth } from "../../context/AuthContext";
import { StatusBadge } from "../../components/StatusBadge";
import { PageHeader } from "../../components/PageHeader";
import { Button } from "../../components/ui/button";
import { DashboardStats } from "../../components/DashboardStats";
import { OficialVigente } from "../../components/OficialVigente";

const Info = ({ label, value, testId }) => (
  <div>
    <p className="text-xs uppercase tracking-wider text-slate-500">{label}</p>
    <p className="text-sm text-slate-900 mt-1" data-testid={testId}>{value}</p>
  </div>
);

const KycLinkCard = ({ estado }) => {
  const [link, setLink] = useState(null);
  const [err, setErr] = useState(null);
  const generar = async () => {
    try {
      const { data } = await api.get("/company/kyc-link");
      setLink(publicUrl(data.path));
    } catch (e) {
      setErr(errMsg(e));
    }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4" data-testid="kyc-link-card">
      <div className="flex items-center gap-2"><Link2 size={18} className="text-blue-700" /><h2 className="font-heading font-semibold">Link de verificación KYC</h2></div>
      {estado !== "activa" && (
        <p className="text-sm text-amber-700 flex items-center gap-2"><Lock size={14} /> Disponible cuando IntiCheck active tu empresa.</p>
      )}
      {link ? (
        <div className="flex gap-2">
          <code className="flex-1 font-mono text-xs bg-slate-100 text-cyan-700 px-3 py-2 rounded break-all" data-testid="kyc-link-value">{link}</code>
          <Button variant="outline" size="icon" onClick={() => { navigator.clipboard.writeText(link); toast.success("Link copiado"); }} data-testid="kyc-link-copy"><Copy size={16} /></Button>
        </div>
      ) : (
        <Button onClick={generar} className="bg-slate-900 hover:bg-slate-800" data-testid="kyc-link-generate">Obtener link</Button>
      )}
      {err && <p className="text-sm text-rose-700" data-testid="kyc-link-error">{err}</p>}
    </div>
  );
};

export default function Resumen() {
  const { me } = useAuth();
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/company").then((r) => setC(r.data));
  }, []);
  if (!c) return null;
  return (
    <div className="space-y-8" data-testid="company-summary">
      <PageHeader overline={`Hola, ${me.usuario.nombre}`} title={c.marca?.nombre_visible || c.nombre_fantasia}>
        <StatusBadge value={c.estado} testId="company-status-badge" />
      </PageHeader>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Info label="RUT" value={c.rut} testId="company-rut" />
          <Info label="Razón social" value={c.razon_social} />
          <Info label="Estado UAF" value={ESTADOS_UAF[c.estado_uaf]} testId="company-uaf" />
          <Info label="Registrada" value={fmtFecha(c.created_at)} />
          <Info label="Representante legal" value={`${c.representante_legal.nombre} · ${c.representante_legal.run}`} />
          <Info label="Oficial de cumplimiento" value={`${c.oficial_cumplimiento.nombre} · ${c.oficial_cumplimiento.correo}`} />
        </div>
        <KycLinkCard estado={c.estado} />
      </div>
      {me.usuario.rol !== "operator" && <OficialVigente />}
      {me.usuario.rol !== "operator" && <DashboardStats />}
    </div>
  );
}
